import * as React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { GlobalStateShared, GlobalPrivateState } from 'src/api';
import { hasModal } from './Modal.reducer';
import { Dispatch } from 'redux';
import { modalActions } from './Modal.action';
import { parse as qsParse } from 'qs';
import { Modal, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Redirect } from 'react-router';

export interface ModalContainerProps {
  byQuery?: boolean;
  children: React.ReactNode;
  showCloseBtn?: boolean;
  className?: string | string[] | {[key: string]: boolean};
  dispatch: Dispatch;
  id: keyof GlobalStateShared['modals'];
  location: GlobalStateShared['router']['location'];
  modals: GlobalStateShared['modals'];
}

export interface ModalContainerState {
  shouldRedirect: boolean;
}

export default class ModalContainerComponent extends React.Component<ModalContainerProps, ModalContainerState> {
  constructor(props: ModalContainerProps) {
    super(props);

    this.handleClose = this.handleClose.bind(this);

    this.state = {
      shouldRedirect: false,
    };
  }
  componentDidMount() {
    const {
      dispatch,
      id,
      modals,
    } = this.props;

    if (!hasModal(id, modals)) {
      dispatch(modalActions.register({
        id, 
        toggle: this.toggleStateByQuery === undefined ? false : this.toggleStateByQuery,
      }));
    }
  }

  componentDidUpdate(prevProps: ModalContainerProps) {
    const {
      dispatch,
      location,
      id,
      modals
    } = this.props;

    const prevLocation = prevProps.location;

    
    if (prevLocation.search !== location.search && hasModal(id, modals) && modals[id] !== undefined) {
      dispatch(modalActions.toggle({
        id,
        toggle: this.toggleStateByQuery === undefined ? false : this.toggleStateByQuery,
      }));
    }

    const {
      shouldRedirect
    } = this.state;

    if (shouldRedirect) {
      this.setState({
        shouldRedirect: false,
      });
    }
  }

  public render() {
    return (
      <Modal
        className={classNames(this.props.className)}
        isOpen={this.toggle}
      >
        {this.props.showCloseBtn && (
          <Button
            className="close-btn" 
            aria-label="Close"
            onClick={this.handleClose}
          >
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        )}
        {this.props.children}
        {this.props.byQuery && this.state.shouldRedirect && (
          <Redirect to={this.props.location.pathname} />
        )}
      </Modal>
    );
  }

  private handleClose() {
    const {
      byQuery,
      dispatch,
      id,
      modals
    } = this.props;
    
    if (hasModal(id, modals) && modals[id] !== undefined) {
      if (byQuery) {
        this.setState({
          shouldRedirect: true,
        });
      } else {
        dispatch(modalActions.toggle({
          id,
          toggle: this.toggleStateByQuery === undefined ? false : this.toggleStateByQuery,
        }));
      }
    }
  }

  private get toggle(): boolean {
    const {
      id,
      modals,
    } = this.props;

    if (hasModal(id, modals) && modals[id] !== undefined) {
      return modals[id];
    }
    return false;
  }

  private get toggleStateByQuery(): boolean | undefined {
    const {
      byQuery,
      location,
      id
    } = this.props;

    if (!byQuery) {
      return undefined;
    }

    const queryStrings: {[key: string]: 'true' | 'false' | boolean} = qsParse(location.search.substring(1));

    if (queryStrings && queryStrings[id]) {
      if(typeof queryStrings[id] === 'boolean') {
        return queryStrings[id] as boolean;
      }
    }

    if (queryStrings[id] === ('true' || 'false')) {
      return queryStrings[id] === 'true' ? true : queryStrings[id] === 'false' ? false : undefined;
    }

    return undefined;
  }
}

export const ModalContainer = connect((state: GlobalPrivateState) => ({
  location: state.router.location,
  modals: state.modals,
}))(ModalContainerComponent);
